import {
  Component,
  Input,
  OnInit
} from '@angular/core';



export class UserAvatarComponent implements OnInit {
   imgSrc: string ;
   imgTooltip: string ;
   imgPlacement: string;

  ngOnInit() { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'imgSrc': [{ type: Input, args: ['imgSrc', ] },],
'imgTooltip': [{ type: Input, args: ['imgTooltip', ] },],
'imgPlacement': [{ type: Input, args: ['imgPlacement', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
